import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

class StreamingSection extends React.Component {
    render() {
        const { model } = this.props;
        const { streamstatus, streamservertype, streamdestination } = model;
        return (
            <Section title="Streaming">
                <List>
                    <Row>
                        <Label>Status</Label>
                        <Value>
                            {streamstatus === 'enabled' ? 'STREAMING' : 'IDLE'}
                        </Value>
                    </Row>

                    <Row>
                        <Label>Mode</Label>
                        <Value>{streamservertype}</Value>
                    </Row>
                    <Row>
                        <Label>Stream URL</Label>
                        <Value>{streamdestination}</Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(StreamingSection);



// WEBPACK FOOTER //
// ./src/sections/Streaming.js